<template>
    <v-row dense>
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Purchase orders
        </v-col>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            class="elevation-1"
            hide-default-header
            hide-default-footer
            @click:row="handleClick"
            dense
        >
          <template v-slot:item.poStatus="{item}">
            <v-chip small outlined :color="statusColor(item.poStatus)" dark>
              {{ item.poStatus}}
            </v-chip>
          </template>

          <template v-slot:item.clubFitter="{item}">
            {{ item.clubFitter.displayName }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
</template>

<script>
export default {
  data: () => {
    return {
      headers: [
        {
          text: 'ID',
          value: 'poNumber',
        },
        {
          text: 'Status',
          value: 'poStatus',
        },
        {
          text: 'Status',
          value: 'supplier.name',
        },
      ]
    }
  },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    methods:{
        open(id){
            this.$router.push('/purchase-order/view/'+id);
            this.$emit('close')
        },
      handleClick(item) {
        this.open(item.id)
      },
      statusColor(status){

        const colors = {
          draft: 'default',
          validated: 'warning',
          partialyReceived: 'info',
          received: 'success',
          cancelled: 'error',
          delete: 'error'
        }

        return colors[status] || 'default'

      }
    }
}
</script>